module.exports = __webpack_public_path__ + "static/RunApp-6011587f22a31ca23878c80caf7062b6.png";